import './AllPackagesPage.css'

import { useEffect, useState } from 'react'
import { Spinner, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import returnIcon from '../../../imgs/left-arrow.png'
import refreshIcon from '../../../imgs/refresh.png'
import { getAllPackages, updatePackage } from '../../../services/packages'

export default function AllPackagesPage() {
  const { loggedUser } = useSelector(state => state.user)

  const [selectedPackage, _setSelectedPackage] = useState({})
  const [selectedLine, setselectedLine] = useState(null)
  const [selectedCloset, setselectedCloset] = useState(null)
  const [packagesObj, setPackagesObj] = useState(false)
  const [packagesByTime, setpackagesByTime] = useState([])
  const [closets, setClosets] = useState(false)
  const [closetPackages, setClosetPackages] = useState(false)
  const [lostPackages, setlostPackages] = useState(false)
  const [_packagesArr, setPackagesArr] = useState([])

  const getDataOf = async () => {
    try {
      let filters = {
        isShipped: false,
        warehouse: loggedUser.UserAttributes['custom:warehouse'],
      }

      const data = await getAllPackages(filters)
      let packages = data.items
      console.log('🚀 - getDataOf - packages', packages)

      //filter out the packages without location
      packages = packages.filter(p => p.warehouseLocation)
      console.log('🚀 - getDataOf - filtered packages', packages)
      setPackagesArr(packages)

      //filter out the lost packages + group by lost
      let lostPackages = []
      packages = packages.filter(p => {
        if (p.isLost) lostPackages.push(p)
        return !p.isLost
      })

      let packagesByLinesObj = {}
      let pByTime = [[], [], []]

      packages.forEach(p => {
        //group by lines
        if (!packagesByLinesObj[p.warehouseLocation[0]]) packagesByLinesObj[p.warehouseLocation[0]] = []
        packagesByLinesObj[p.warehouseLocation[0]].push(p)

        //group by time
        switch (true) {
          case Date.now() - new Date(p.datePayed).getTime() >= 604800000:
            pByTime[2].push(p)
            break
          case Date.now() - new Date(p.datePayed).getTime() >= 432000000:
            pByTime[1].push(p)
            break
          case Date.now() - new Date(p.datePayed).getTime() >= 259200000:
            pByTime[0].push(p)
            break
        }
      })
      console.log('🚀 - getDataOf - packagesByLinesObj', packagesByLinesObj)
      console.log('🚀 - getDataOf - pByTime', pByTime)
      console.log('🚀 - getDataOf - lostPackages', lostPackages)

      setPackagesObj(packagesByLinesObj)
      setpackagesByTime(pByTime)
      setlostPackages(lostPackages)
    } catch (error) {
      throw error
    }
  }

  const toggleDetails = elId => {
    let el = document.getElementById(elId)
    if (el.style.display === 'none') el.style.display = 'contents'
    else el.style.display = 'none'
  }

  const lostPackage = async packageId => {
    try {
      const res = await updatePackage(packageId, {
        isLost: new Date().toISOString().split('T')[0],
      })
      console.log('🚀 - lostPackage - res', res)

      updateState(packageId)
    } catch (error) {
      console.log(error)
      alert(`Error! ${error.response.data.message}`)
    }
  }

  const chooseByTime = chosenPackages => {
    let packagesObj = {}
    chosenPackages.forEach(p => {
      if (!packagesObj[p.warehouseLocation[0]]) packagesObj[p.warehouseLocation[0]] = []
      packagesObj[p.warehouseLocation[0]].push(p)
    })

    console.log('🚀 - chooseByTime - packagesObj', packagesObj)
    setPackagesObj(packagesObj)
  }

  const chooseLineHandler = (linePackages, line) => {
    let packagesObj = {}
    linePackages.forEach(p => {
      if (!packagesObj[p.warehouseLocation[1]]) packagesObj[p.warehouseLocation[1]] = []
      packagesObj[p.warehouseLocation[1]].push(p)
    })

    setselectedLine(line)
    setClosets(packagesObj)
  }

  const chooseClosetHandler = (closetPackages, closet) => {
    let closetPackagesByShelf = closetPackages.sort((a, b) => {
      return a.warehouseLocation[2].localeCompare(b.warehouseLocation[2])
    })

    setselectedCloset(closet)
    setClosetPackages(closetPackagesByShelf)
  }

  // const goBackToLines = () => {
  //   setClosets(false)
  //   setselectedLine(null)
  // }

  // const goBackToClosets = () => {
  //   setClosetPackages(false)
  //   setselectedCloset(null)
  // }

  let prevShelf
  const isNextShelf = p => {
    let jsx = ''
    if (prevShelf !== p.warehouseLocation[2])
      jsx = (
        <tr>
          <td colSpan='4' style={{ borderTop: 'none', textAlign: 'center' }}>
            {p.warehouseLocation[2]}
          </td>
        </tr>
      )
    prevShelf = p.warehouseLocation[2]
    return jsx
  }

  function getColor(length) {
    let value = +length

    switch (true) {
      case value < 10:
        return '#00aeef'
      case value < 20:
        return '#f7eb0b'
      case value < 30:
        return '#f7940b'
      case value < 40:
        return '#ef1b1b'
    }

    // Interpolating Between Any Two Colours
    // return `hsl(${+value*10.6}, 70%, 50%)`;
  }

  const updateState = packageId => {
    //if worker scan without choosing line or closet (package has location)
    let line
    if (!selectedLine || selectedLine !== selectedPackage.warehouseLocation[0]) {
      line = selectedPackage.warehouseLocation[0]
    } else line = selectedLine
    // console.log('updateState - line:', line)

    let closet
    if (!closet || selectedCloset !== selectedPackage.warehouseLocation[1]) {
      closet = selectedPackage.warehouseLocation[1]
    } else closet = selectedCloset
    // console.log('updateState - closet:', closet)

    //if worker chose line and closet
    //get only the line packages - cause thats what we need to update
    const closetPackages1 = packagesObj[line].filter(p => p.warehouseLocation[1] == closet)

    //filter out the shipped packgae
    let updatedClosetPackages1 = closetPackages1.filter(p => p.id !== selectedPackage.id)

    //if the "lostPackage" function called this function, update the state without the lost package
    if (packageId) updatedClosetPackages1 = updatedClosetPackages1.filter(p => p.id !== packageId)

    //sort by shelfs
    const updatedClosetPackages1Sorted = updatedClosetPackages1.sort((a, b) => {
      return a.warehouseLocation[2].localeCompare(b.warehouseLocation[2])
    })
    setClosetPackages(updatedClosetPackages1Sorted)

    //update packagesObj so if the worker will go back on the app it will be updated
    let updatedPackagesObj = packagesObj[line].filter(p => p.id !== selectedPackage.id)
    if (packageId) updatedPackagesObj = updatedPackagesObj.filter(p => p.id !== packageId)

    setPackagesObj({ ...packagesObj, [line]: updatedPackagesObj })
  }

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
    getDataOf()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRefresh = () => {
    setPackagesObj(false)
    setPackagesArr([])
    setpackagesByTime([])
    setlostPackages([])
    setClosets(false)
    setClosetPackages(false)
    getDataOf()
  }

  const handleReturn = () => {
    if (closetPackages) setClosetPackages(false)
    else setClosets(false)

    getDataOf()
  }
  return (
    <div className='app-cmp'>
      <>
        <>
          {!packagesObj ? (
            <div style={{ marginTop: '10%', textAlign: 'center' }}>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              <div className='bgs-actions'>
                <img src={returnIcon} onClick={() => handleReturn()} />
                <img src={refreshIcon} onClick={() => handleRefresh()} />
              </div>

              <div className='app-storage-cont'>
                {!closets ? (
                  <>
                    <div className='app-storage-specials'>
                      <div className='app-card-special' onClick={() => chooseByTime(lostPackages)}>
                        Lost Packages List ({lostPackages.length})
                      </div>
                      <div className='app-storage-time'>
                        <div className='app-card-special' onClick={() => chooseByTime(packagesByTime[0])}>
                          3 Days ({packagesByTime[0]?.length})
                        </div>
                        <div className='app-card-special' onClick={() => chooseByTime(packagesByTime[1])}>
                          5 Days ({packagesByTime[1]?.length})
                        </div>
                        <div className='app-card-special' onClick={() => chooseByTime(packagesByTime[2])}>
                          7 Days ({packagesByTime[2]?.length})
                        </div>
                      </div>
                    </div>

                    <h3 className='app-storage-title'>Lines</h3>
                    {Object.keys(packagesObj).map((line, idx) => {
                      return (
                        <div
                          key={idx}
                          className='app-card'
                          style={{
                            backgroundColor: getColor(packagesObj[line].length),
                          }}
                          onClick={() => chooseLineHandler(packagesObj[line], line)}
                        >
                          {line} ({packagesObj[line].length})
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {!closetPackages ? (
                      <>
                        <h3 className='app-storage-title'>Closets in Line {selectedLine}</h3>
                        {Object.keys(closets).map((closet, idx) => {
                          return (
                            <div
                              key={idx}
                              className='app-card'
                              style={{
                                backgroundColor: getColor(closets[closet].length),
                              }}
                              onClick={() => chooseClosetHandler(closets[closet], closet)}
                            >
                              {closet} ({closets[closet].length})
                            </div>
                          )
                        })}
                      </>
                    ) : (
                      <>
                        <h4>
                          Packages in Line {selectedLine}, Closet {selectedCloset}
                        </h4>
                        {
                          <Table>
                            <thead
                              style={{
                                backgroundColor: '#fcde00',
                                color: 'white',
                              }}
                            >
                              <tr>
                                <th> # </th>
                                <th> XLT </th>
                                <th> Costumer </th>
                                <th> Location </th>
                                <th> Status </th>
                              </tr>
                            </thead>
                            <tbody>
                              {closetPackages.map((item, idx) => {
                                return (
                                  <>
                                    {isNextShelf(item)}
                                    <tr
                                      onClick={() => {
                                        toggleDetails(idx + 1)
                                      }}
                                    >
                                      <td>{idx + 1}</td>
                                      <td style={{ width: '135px' }}>{item.trackingNumberToIsrael}</td>
                                      <td> {item.costumer_firstName + ' ' + item.costumer_LastName} </td>
                                      <td>{item.warehouseLocation}</td>
                                      <td>{item.isPaid ? 'Paid' : 'Not Paid'}</td>
                                    </tr>

                                    <tr
                                      style={{
                                        display: 'none',
                                        fontSize: '0.8rem',
                                      }}
                                      id={idx + 1}
                                    >
                                      <td></td>
                                      <td style={{ width: '135px' }}>
                                        {item?.contents?.map((c, i) => {
                                          return (
                                            <span key={i}>
                                              {i > 0 && ', '}
                                              {c.productCategory} X {c.quantity}
                                            </span>
                                          )
                                        })}
                                      </td>
                                      <td>
                                        {item.brand} , {Math.round(item.weight * 100) / 100}KG
                                      </td>
                                      <td
                                        style={{
                                          color: 'blue',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => lostPackage(item.id)}
                                      >
                                        {' '}
                                        Lost{' '}
                                      </td>
                                    </tr>
                                  </>
                                )
                              })}
                            </tbody>
                          </Table>
                        }
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      </>
    </div>
  )
}
